{
    "2_IsM": {
        "position": {
            "x": 9,
            "y": 3,
            "z": 1
        },
        "key": "2_IsM",
        "tag": "badspawn"
    },
    "9q3_f": {
        "position": {
            "x": 8,
            "y": 6,
            "z": 1
        },
        "key": "9q3_f",
        "tag": "goodspawn"
    },
    "EgMQu": {
        "position": {
            "x": 7,
            "y": 6,
            "z": 1
        },
        "key": "EgMQu",
        "tag": "goodspawn"
    },
    "mMjlI": {
        "position": {
            "x": 6,
            "y": 6,
            "z": 1
        },
        "key": "mMjlI",
        "tag": "goodspawn"
    },
    "3ECQ5": {
        "position": {
            "x": 9,
            "y": 6,
            "z": 1
        },
        "key": "3ECQ5",
        "tag": "goodspawn"
    },
    "sWcQ1": {
        "position": {
            "x": 8,
            "y": 3,
            "z": 1
        },
        "key": "sWcQ1",
        "tag": "badspawn"
    },
    "tQTHR": {
        "position": {
            "x": 7,
            "y": 3,
            "z": 1
        },
        "key": "tQTHR",
        "tag": "badspawn"
    },
    "bB_Pn": {
        "position": {
            "x": 6,
            "y": 3,
            "z": 1
        },
        "key": "bB_Pn",
        "tag": "badspawn"
    },
    "mZBKQ": {
        "position": {
            "x": 6,
            "y": 4,
            "z": 1
        },
        "key": "mZBKQ",
        "tag": "badspawn"
    },
    "rxNSy": {
        "position": {
            "x": 7,
            "y": 4,
            "z": 1
        },
        "key": "rxNSy",
        "tag": "badspawn"
    },
    "YoaIE": {
        "position": {
            "x": 8,
            "y": 4,
            "z": 1
        },
        "key": "YoaIE",
        "tag": "badspawn"
    },
    "PwvFm": {
        "position": {
            "x": 9,
            "y": 4,
            "z": 1
        },
        "key": "PwvFm",
        "tag": "badspawn"
    }
}